import { SimpleTreeView, useTreeViewApiRef } from "@mui/x-tree-view";
import CustomTreeItem from "./customTreeItem";
import { Stack, Typography, useTheme } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { use } from "react";

export default function CustomTreeView(props) {
  const {
    fullWidth = false,
    onlyExpand = true,
    defaultExpandedItems = [],
    defaultSelectedItems = [],
    items = [],
    title = "",
    open = false,
    setOpen = () => {},
    closeOnClickItem = false,
    titlePage = "",
    setTitlePage = () => {},
    setLink = () => {},
    ocultar = false,
    onItemClick = () => {}, // Callback quando um item é clicado
    onItemSelect = () => {}, // Callback quando um item é selecionado
    onItemsIdSelected = () => {}, // Callback quando os IDs dos itens selecionados mudam
    modulesConfig = {},
    setBlockedModal = () => {},
    setProductName = () => {},
  } = props;

  const [selectedItems, setSelectedItems] = useState([]);
  const [expandedItems, setExpandedItems] = useState([]);
  const [groups, setGroups] = useState([]);
  const theme = useTheme();
  const apiRef = useTreeViewApiRef();

  function getExpandedIds(items) {
    const result = [];

    function traverse(nodes) {
      for (const node of nodes) {
        if (node.openItem === true) {
          result.push(node.itemId);
        }
        if (node.nodes && node.nodes.length > 0) {
          traverse(node.nodes);
        }
      }
    }

    traverse(items);
    return result;
  }

  function findAncestors(targetId) {
    const path = [];

    function traverse(nodes, ancestors) {
      for (const node of nodes) {
        const newAncestors = [...ancestors, node.itemId];
        if (node.itemId === targetId) {
          path.push(...ancestors);
          return true;
        }
        if (node.nodes && traverse(node.nodes, newAncestors)) {
          return true;
        }
      }
      return false;
    }

    traverse(items, []);
    return path;
  }
  useEffect(() => {
    if (onlyExpand) setExpandedItems(getExpandedIds(items));
  }, [onlyExpand]);

  useEffect(() => {
    if (defaultSelectedItems.length > 0) {
      setSelectedItems(defaultSelectedItems);
    }
  }, [defaultSelectedItems]);

  useEffect(() => {
    //if (onlyExpand) setExpandedItems(getExpandedIds(items));
    const uniqueGroups = Array.isArray(items)
      ? [...new Set(items.map((item) => item.group))]
      : [];
    if (uniqueGroups.length > 0) setGroups(uniqueGroups);
  }, [ocultar, open, items, selectedItems]);

  const styles = {
    simpleTreeView: {
      width: open ? (fullWidth ? "100%" : 270) : 56,
      paddingX: 1,
      paddingY: "5px",
    },
    title: {
      flexGrow: 1,
      fontWeight: 500,
      fontSize: "14px",
      marginX: 1,
      marginY: 1,
      color: theme.palette.text.secondary,
    },
  };

  const handleClick = (node) => {
    const expanded = expandedItems.find((id) => id === node.itemId);
    const selected = selectedItems.find((id) => id === node.itemId);

    if (expanded) {
      setExpandedItems((prev) => prev.filter((id) => id !== node.itemId));
    } else if (node?.openItem) {
      setExpandedItems((prev) => [...prev, node.itemId]);
    }
    if (!node?.openItem) {
      if (!selected) {
        const ancestors = findAncestors(node.itemId);
        setSelectedItems(() => {
          const newSelection = new Set();
          newSelection.add(node.itemId);
          ancestors.forEach((id) => newSelection.add(id));
          onItemsIdSelected(Array.from(newSelection));
          return Array.from(newSelection);
        });
      }
      onItemClick(node);
    }
  };

  const renderTreeItems = (nodes, parent = null) => {
    return nodes.map((node) => (
      <CustomTreeItem
        key={node.itemId}
        selectedItems={selectedItems}
        open={open}
        setOpen={setOpen}
        apiRef={apiRef}
        closeOnClickItem={closeOnClickItem}
        titlePage={titlePage}
        setTitlePage={setTitlePage}
        setLink={setLink}
        modulesConfig={modulesConfig}
        setBlockedModal={setBlockedModal}
        setProductName={setProductName}
        onItemClick={() => handleClick(node)}
        onItemSelect={() => {
          if (!node?.openItem) {
            onItemSelect(node);
          }
        }}
        paternal={parent}
        {...node}
      >
        {node?.nodes &&
          Array.isArray(node?.nodes) &&
          renderTreeItems(node.nodes, node)}
      </CustomTreeItem>
    ));
  };

  return (
    <SimpleTreeView
      key={"SimpleTreeView"}
      selectedItems={selectedItems}
      defaultExpandedItems={defaultExpandedItems}
      defaultSelectedItems={defaultSelectedItems}
      expandedItems={expandedItems}
      multiSelect
      sx={styles.simpleTreeView}
      apiRef={apiRef}
    >
      <Stack>
        {Array.isArray(groups) &&
          groups.map((group) => (
            <Fragment key={group}>
              {open && (
                <Typography
                  key={group + "_title"}
                  variant="h6"
                  component="div"
                  sx={styles.title}
                >
                  {group}
                </Typography>
              )}
              {Array.isArray(items) &&
                renderTreeItems(items.filter((item) => item?.group == group))}
            </Fragment>
          ))}
      </Stack>
    </SimpleTreeView>
  );
}
